import { user } from './user'
import { IPasswordResetCredentilas } from '../../../types/auth'
import { combineReducers } from 'redux'
import { loginStatus, pubPath, resetConf } from './loginStatus'
import { IUserDetail } from '../../../types/user'

export interface AuthState {
  loginStatus: boolean;
  user: IUserDetail | null;
  pubPath: string;
  resetConf: IPasswordResetCredentilas;
}

const authApp = combineReducers<AuthState>({
  loginStatus,
  user,
  pubPath,
  resetConf
})

export default authApp
